<template>
    <div class="item">
        <van-panel title="Laptop&Desktop" :status="value.type">
            <div>
                <van-cell :title="$t('message.assetNum')" :value="value.asset_num" :border="false" size="small" />
                <van-cell :title="$t('message.serial')" :value="value.serial" :border="false" size="small" />
                <van-cell :title="$t('message.model')" :value="value.model" :border="false" size="small" />
                <!-- <van-cell :title="$t('message.mobile_company')" :value="value.mobile" :border="false" size="small" /> -->
                <van-cell :title="$t('message.bu')" :value="value.bu" :border="false" size="small" />
                <van-cell :title="$t('message.user_name')" :value="value.user_name" :border="false" size="small" />
                <van-cell :title="$t('message.phone')" :value="value.phone" :border="false" size="small" />
                <van-cell :title="$t('message.sign_time')" :value="formatDate(value.sign_time)" :border="false"
                    size="small" />
            </div>
            <div slot="footer" class="item_footer">
                <van-button type="primary" size="small" style="width: 100px" round class="stock-btn"
                    @click="godetailPage">{{ $t('message.error_message_submit') }}
                </van-button>
                <van-button type="primary" size="small" round class="stock-btn" @click="confirmBtn" :disabled="disabled">{{
            $t('message.confirm') }}
                </van-button>
            </div>
        </van-panel>
        <br>
        <div style="font-size: 14px;color:#323233">
            IT 资产领用须知：<br>
            1.点击“确认”确认我已收到上述IT资产；<br>
            2.我将遵守公司合规政策，不安装未授权或非法软件，每60天联网登录VPN；<br>
            3.资产遗失或人为损坏，需按财务账面残值照价赔偿；<br>
            4.雇佣关系终止时，需按时归还资产。<br>

            Instructions for using IT assets:<br>
            1. Click "Confirm" to acknowledge that I have received the above IT assets;<br>
            2. I will abide by the company's compliance policies, not install unauthorized or illegal software, and log
            in
            to the VPN every 60 days;<br>
            3. If assets are lost or damaged, I must pay compensation according to the book value in the finance
            system.<br>
            4. When the employment relationship is terminated, assets must be returned on time.<br>
        </div>
    </div>
</template>
<script>
import { Panel, CellGroup, Cell, Button, Popup, Icon, Toast } from 'vant';
import dayjs from 'dayjs';
export default {
    name: "ListItem",
    components: {
        [Panel.name]: Panel,
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [Button.name]: Button,
        [Popup.name]: Popup,
        [Icon.name]: Icon,
        Toast
    },
    props: {
        value: Object,
        type: String,
        id: String,
        itemType: String
    },
    data() {
        return {
            showDetails: false,
            listType: 'mine',
            disabled: false
        }
    },
    methods: {

        godetailPage() {
            this.$router.push({
                name: 'itemDetail',
                query: { id: this.value.id, type: this.itemType }
            })
        },
        confirmBtn() {
            console.log('type', this.itemType)
            this.$axios.get('onlineSign/submit?id=' + this.id + '&type=' + this.itemType).then(res => {
                console.log(res)
                this.disabled = true
                Toast('操作成功')
            }).catch(res => {
                Dialog.alert({
                    title: '资产确认失败',
                    message: res
                }).then(() => {
                    this.loading = false;
                })
            })
        },
        gotoStock() {
            this.$router.push({
                name: 'stock',
                query: { id: this.value.id, type: this.value.type }
            })
        },
        closeDetails() {
            this.showDetails = false
        },
        formatDate(date) {
            if (date) {
                return dayjs(date).add(8, 'hour').format('YYYY年MM月DD日')
            }
            return ''
        }
    }
}
</script>
<style lang="less" scoped>
.item {
    margin: 8px 15px;

    .item_footer {
        text-align: right;

        button {
            width: 60px;
            margin-left: 10px;
        }
    }

    .detail-container {
        height: 70vh;
        width: 75%;
    }

    .detail-close {
        text-align: center;
        font-size: 35px;
        position: fixed;
        bottom: 0;
    }

    .detail-close-btn {
        font-size: 35px;
        position: fixed;
        bottom: 30px;
    }
}
</style>
